import { filter } from 'lodash';
import PropTypes from 'prop-types';
import { sentenceCase } from 'change-case';
import { useCallback, useEffect, useState } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  Grid,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  tableCellClasses,
  Dialog,
  IconButton,
  DialogActions,
  DialogTitle,
  DialogContent,
  FormControl,
  Select,
  MenuItem,
  Tabs,
  TextField,
  Tab
} from '@mui/material';
import { Box } from '@mui/system';
import { format } from 'date-fns';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
// import { DateRangeStyled } from '../Global/Styling';
import { PayableApi } from '../../utils/Apis';
import { downloadApiData } from '../../store/Slice/Global/GlobalSlice';
import usePayableSelector from '../../store/Slice/Payable/PayableSelector';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import { getPayableListData } from '../../store/Slice/Payable/PayableSlice';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../components/_dashboard/user';
import BrudCrumbs from '../../components/BreadCrumbs';
import { getIcon, JourneyIcon } from '../../vector/index';
import PageTitle from '../../components/PageHeading';
//
import PayableListData from '../../_mocks_/user';
import { fDate } from '../../utils/formatTime';
// styling
import { StyledTableRow, StyledTableCell, DateRangeStyled } from '../Global/Styling';
import PayableToolbar from './PayableToolbar';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import PayableDialogRedux from './PayableInvoicePaidDialog';
import SimplePagination from '../../components/SimplePagination';
import useDebounce from '../../utils/useDebounce';

// ----------------------------------------------------------------------
const TABLE_HEAD = [
  { id: 'id', label: 'File No', alignRight: false },
  { id: 'name', label: 'Borrower Name', alignRight: false },
  { id: 'bankName', label: 'Bank Name', alignRight: false },
  { id: 'branchName', label: 'Branch Name', alignRight: false },
  { id: 'loanType', label: 'Loan Name', alignRight: false },
  { id: 'partnerName', label: 'Partner Name', alignRight: false },
  { id: 'invoiceNumber', label: 'Invoice No', alignRight: false },
  { id: 'amount', label: 'Invoice Amount', alignRight: false },
  { id: 'partnerPayout', label: 'Total Amount', alignRight: false },
  // { id: 'created', label: 'Due Date', alignRight: false },
  // { id: 'modifiedOn', label: 'Paid on', alignRight: false },
  { id: 'statusPayable', label: 'Status', alignRight: false },
  { id: '', label: 'ACTION' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) => _user.borrowerName.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function Payable() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [openPayment, setOpenPayment] = useState(false);
  const [selectedPaybleId, setSelectedPaybleId] = useState(null);
  const [selectedInvoiceAmount, setSelectedInvoiceAmount] = useState('');
  const [downloadDialog, setDownloadDialog] = useState(false);
  const [selectDate, setSelectDate] = useState(' ');
  const [filterState, setFilterState] = useState({
    partnerId: null,
    bankId: null,
    invoiceNo: null,
    status: null,
    fromDate: null,
    toDate: null
  });
  const [filterDatesRange, setFilterDatesRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);

  const { LoginData } = useLoginSelector();
  const dispatch = useDispatch();
  const { PayableListData } = usePayableSelector();
  const debouncedSearch = useDebounce(filterName, 600);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = PayableListData?.map((n) => n.paybleId);
      setSelected(newSelecteds || []);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleDateChange = (ranges) => {
    const { selection } = ranges;
    setFilterDatesRange([selection]);
    setFilterState((prev) => ({
      ...prev,
      fromDate: selection.startDate ? format(selection.startDate, 'yyyy-MM-dd') : null,
      toDate: selection.endDate ? format(selection.endDate, 'yyyy-MM-dd') : null
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      fontSize: 13,
      fontWeight: 'bold',
      padding: '6px'
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 11,
      padding: '4px 6px'
    }
  }));
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - (PayableListData?.length || 0)) : 0;

  const filteredUsers = PayableListData || [];

  const isUserNotFound = filteredUsers.length === 0;

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const checkDownload = () => {
    setDownloadDialog(true);
  };

  const handleDownload = async (id) => {
    console.log('id from action', id);
    let payableValue;
    if (id) {
      payableValue = [id];
    } else {
      payableValue = [];
    }
    const credentials = {
      userId: LoginData?.userId,
      companyId: LoginData?.companyId,
      paybleIds: selected.length > 0 ? selected : payableValue,
      filterModel: {
        partnerId: filterState?.partnerId,
        bankId: filterState?.bankId,
        invoiceNo: filterState?.invoiceNo,
        status: filterState?.status,
        fromDate: filterState?.fromDate,
        toDate: filterState?.toDate
      }
    };

    try {
      const result = await dispatch(downloadApiData(PayableApi?.payableDownload, credentials));

      if (result?.success && result?.data) {
        let fileName;
        if (selected.length === 1 || id) {
          fileName = `PayableDataDownload_${format(new Date(), 'dd-MM-yyyy_HH-mm-ss')}.pdf`;
        } else {
          fileName = `PayableDataDownload_${format(new Date(), 'dd-MM-yyyy_HH-mm-ss')}.zip`;
        }

        const url = window.URL.createObjectURL(result.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Download failed:', result.error);
      }
    } catch (error) {
      console.error('Export error:', error);
    }
  };

  const getBankListApi = useCallback(() => {
    const credentials = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      filterModel: {
        partnerId: filterState.partnerId || null,
        bankId: filterState.bankId || null,
        invoiceNo: filterState.invoiceNo || null,
        fromDate: filterState.fromDate || null,
        toDate: filterState.toDate || null
      },
      entityListRequestModel: {
        sortOrder: order || 'desc',
        pageSize: rowsPerPage,
        pageNumber: page + 1,
        searchLiteral: debouncedSearch?.length >= 2 ? debouncedSearch : null
      }
    };

    dispatch(getPayableListData(credentials));
  }, [LoginData, filterState, order, page, rowsPerPage, debouncedSearch, dispatch]);

  useEffect(() => {
    getBankListApi();
  }, [getBankListApi]);

  useEffect(() => {
    if (!PayableListData) {
      setHasNextPage(true);
      return;
    }
    setHasNextPage(PayableListData.length >= rowsPerPage);
  }, [PayableListData, rowsPerPage]);

  useEffect(() => {
    setPage(0);
  }, [debouncedSearch, filterState]);

  return (
    <Page title="Partner Management System || Payable">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="List of Partner Invoice" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Scrollbar>
            <Card>
              <PayableToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
                parent="payable"
                selected={selected}
                handleDownload={selected.length === 0 ? checkDownload : handleDownload}
                filterParameter={filterState}
                setFilterParameter={setFilterState}
              />
              <TableContainer sx={{ height: '60vh', minWidth: 800, overflow: 'auto' }}>
                <Table stickyHeader>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={PayableListData?.length || 0}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                    isCheckBox="true"
                  />
                  <TableBody>
                    {filteredUsers.map((row, index) => {
                      const {
                        paybleId,
                        fileNo,
                        borrowerName,
                        bankId,
                        bankName,
                        branchId,
                        branchName,
                        loanId,
                        loanName,
                        partnerId,
                        partnerName,
                        invoiceNo,
                        invoiceAmount,
                        partnerPayout,
                        dueDate,
                        paidOn,
                        payableStatus,
                        status
                      } = row;
                      const isItemSelected = selected.indexOf(paybleId) !== -1;
                      return (
                        <StyledTableRow
                          hover
                          key={index + 1}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              disabled={row?.partnerId === 0}
                              onChange={(event) => handleClick(event, paybleId)}
                            />
                          </TableCell>

                          <StyledTableCell align="">{fileNo}</StyledTableCell>
                          <StyledTableCell align="">{borrowerName}</StyledTableCell>
                          <StyledTableCell align="">{bankName}</StyledTableCell>
                          <StyledTableCell align="">{branchName}</StyledTableCell>
                          <StyledTableCell align="">{loanName}</StyledTableCell>
                          <StyledTableCell align="">{partnerName}</StyledTableCell>
                          <StyledTableCell align="">{invoiceNo}</StyledTableCell>
                          <StyledTableCell align="">{invoiceAmount}</StyledTableCell>
                          <StyledTableCell align="">{partnerPayout}</StyledTableCell>
                          {/* <StyledTableCell align="">{dueDate}</StyledTableCell>
                          <StyledTableCell align="">{paidOn}</StyledTableCell> */}
                          <StyledTableCell align="left">
                            <Label
                              variant="ghost"
                              color={
                                (payableStatus === 'PENDING' && 'error') ||
                                (payableStatus === 'PAID' && 'success') ||
                                'warning'
                              }
                            >
                              {payableStatus}
                            </Label>
                          </StyledTableCell>

                          <StyledTableCell align="" width={110}>
                            <UserMoreMenu
                              rowId={row}
                              parent="payable"
                              handlePaymentAction={() => {
                                setSelectedPaybleId(row.paybleId);
                                setSelectedInvoiceAmount(row.invoiceAmount);
                                setOpenPayment(true);
                              }}
                              selected={selected}
                              onPayClick={handleDownload}
                            />
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <StyledTableCell
                          align="center"
                          colSpan={TABLE_HEAD.length + 1}
                          sx={{ py: 3 }}
                        >
                          <SearchNotFound searchQuery={filterName} />
                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              <SimplePagination page={page} setPage={setPage} hasNextPage={hasNextPage} />
              <PayableDialogRedux
                openPayment={openPayment}
                setOpenPayment={setOpenPayment}
                userId={LoginData?.userId}
                paybleId={selectedPaybleId}
                invoiceAmount={selectedInvoiceAmount}
                onSuccess={() => {
                  getBankListApi(); // refresh list
                }}
              />
              {/* payment pop up end */}
              {/* payment pop up start */}
              <Dialog open={downloadDialog} onClose={(e) => setDownloadDialog(false)} fullWidth>
                <DialogTitle className="popupTitle">
                  <Typography variant="h6">Download Invoice</Typography>
                  <IconButton onClick={(e) => setDownloadDialog(false)} size="small">
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs sx={{ position: 'relative' }}>
                      <Box className="displayDateRange">
                        {filterDatesRange[0].startDate !== null
                          ? `${fDate(filterDatesRange[0].startDate)} to `
                          : ''}
                        {filterDatesRange[0].endDate !== null
                          ? fDate(filterDatesRange[0].endDate)
                          : ''}
                        {filterDatesRange[0].startDate === null &&
                        filterDatesRange[0].endDate === null ? (
                          <Typography className="dissabledMenu">Select Date Range</Typography>
                        ) : (
                          ''
                        )}
                      </Box>
                      <Select
                        fullWidth
                        inputProps={{
                          className: 'textInput'
                        }}
                        MenuProps={{
                          className: 'menuOpened'
                        }}
                        value=" "
                        className="datesSelect"
                      >
                        <DateRangeStyled
                          editableDateInputs={false}
                          onChange={handleDateChange}
                          moveRangeOnFirstSelection={false}
                          ranges={filterDatesRange}
                          className="dateRangePicker"
                        />
                      </Select>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button onClick={(e) => handleDownload()} variant="contained" className="mainBtn">
                    Submit
                  </Button>
                </DialogActions>
              </Dialog>
            </Card>
          </Scrollbar>
        </Box>
      </Container>
    </Page>
  );
}
